import { RunDataConversionService } from "./EVADataService";
import { getRandomLightColor } from "./EVAService";

const processGraphView = (item, layout, headerToMultiSelect, visualData, dataValue, gridHeader) => {
    if(item.visual) {
       
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.visual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.visual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.visual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.visual.y;
        return item.tempVisual
    } else {
        if (!visualData || !visualData?.dataLabel) return 

        const res = headerToMultiSelect.filter((e) => e.name.includes(`${visualData.dataLabel.replace(/\s*\[.*?\]/g, '')}`));
        // const res = headerToMultiSelect.filter((e) => e.name === visualData.dataLabel);
        if(res.length === 0) return 
        const visual = {
            "selectedViewOption": item.visual_type,
            "selectedGroups": getDataValue(dataValue && dataValue.length > 0 && dataValue !== undefined ? dataValue : visualData.dataValue, gridHeader),
            "selectedGroup": visualData.groupings,
            "chartHeader": [],
            "selectedFooter": { id: res[0].id, label: visualData.dataLabel },
            "selectedGraphHeaderOption": null,
            "headerToMultiSelect": headerToMultiSelect,
            "chartData": {
                "labels": [],
                "datasets": []
            },
            "width": layout && layout !== undefined ? layout.w : item.tempVisual.width,
            "height": layout && layout !== undefined ? layout.h : item.tempVisual.height,
            "x": layout && layout !== undefined ? layout.x : item.tempVisual.x,
            "y": layout && layout !== undefined ? layout.y : item.tempVisual.y
        }

        item.tempVisual = visual
        return visual
    }
}
const getDataValue = (dataValue, gridHeader) => {
    const res = [];
    if (!Array.isArray(dataValue)) {
        console.warn('Expected array but got:', dataValue);
        return res;
    }
    dataValue && dataValue.forEach((item, index) => {
        let label = item.replace(/\s*\[.*?\]/g, '').trim();
        let data = item;
        let colIndex
        gridHeader.forEach(header => {
            const regex = /^\[date\d+\]$/;
            if (regex.test(item)) {
                if (header.includes(`${item}`)) {
                    label = header.replace(/\s*\[.*?\]/g, '')
                    data = label;
                    // colIndex = gridHeader.indexOf(header)
                }
            } else if (header.includes(`${ label.replace(/\s*\[.*?\]/g, '').trim() }`)) {
                label = header.replace(/\s*\[.*?\]/g, '')
                data = label;
                // colIndex = gridHeader.indexOf(header)
            }
        });
        res.push({
            label,
            data,
            // colIndex,
            color: defaultControl(index),
            isOpen: false
        });
    });
    return res;
};
const processPieGraph = (item, layout, headerToMultiSelect, visualData) => {
    // console.log(item)

    if(item.visual) {
       
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.visual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.visual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.visual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.visual.y;
        return item.tempVisual
    } else {
        if (!visualData || !visualData?.dataLabel) return 
        
        const dataLabel = headerToMultiSelect.filter((e) => e.name === visualData.dataLabel);
        const dataValue = headerToMultiSelect.filter((e) => e.name === visualData.dataValue);

        if(dataLabel.length === 0 || dataValue.length === 0) return 
        const visual = {
            "selectedGroup": visualData.groupings,
            "selectedGroups": [
                {
                    "label": "",
                    "data": "",
                    "color": "rgb(146, 166, 198)",
                    "isOpen": false
                }
            ],
            "chartHeader": [],
            "selectedLabel": { id: dataLabel[0].id, label: visualData.dataLabel },
            "selectedGraphHeaderOption": null,
            "selectedData": { id: dataValue[0].id, label: visualData.dataValue },
            "headerToMultiSelect": headerToMultiSelect,
            "pieItem": [],
            "selectedViewOption": "Pie Chart",
            "width": layout && layout !== undefined ? layout.w : item.tempVisual.width,
            "height": layout && layout !== undefined ? layout.h : item.tempVisual.height,
            "x": layout && layout !== undefined ? layout.x : item.tempVisual.x,
            "y": layout && layout !== undefined ? layout.y : item.tempVisual.y
        }
        item.tempVisual = visual
        return visual
    }
}
const processCardView = (item, layout, headerToMultiSelect, visualData, sqlresult, gridHeader) => {
    const cleanedHeader = gridHeader.map(h => h.replace(/\s*\[.*?\]/g, ''));
    setToCardView(cleanedHeader, sqlresult, item)
    
    if(item.visual) {
       
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.visual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.visual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.visual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.visual.y;
        return item.tempVisual
    }

    if(item.tempVisual) {
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.tempVisual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.tempVisual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.tempVisual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.tempVisual.y;
        return item.tempVisual
    } else {
        const visual = {
            "width": layout && layout !== undefined ? layout.w : item.tempVisual.width,
            "height": layout && layout !== undefined ? layout.h : item.tempVisual.height,
            "x": layout && layout !== undefined ? layout.x : item.tempVisual.x,
            "y": layout && layout !== undefined ? layout.y : item.tempVisual.y
        }
        item.tempVisual = visual
        return visual
    }
}
const processGridView = (item, layout, headerToMultiSelect, visualData, sqlresult, gridHeader) => {
    setToCardView(gridHeader, sqlresult, item)

    if(item.visual) {
       
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.visual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.visual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.visual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.visual.y;
        return item.tempVisual
    }

    if(item.tempVisual) {
        item.tempVisual.width = layout && layout !== undefined ? layout.w : item.tempVisual.width;
        item.tempVisual.height = layout && layout !== undefined ? layout.h : item.tempVisual.height;
        item.tempVisual.x = layout && layout !== undefined ? layout.x : item.tempVisual.x;
        item.tempVisual.y = layout && layout !== undefined ? layout.y : item.tempVisual.y;
        return item.tempVisual
    } else {
        const visual = {
            "width": layout && layout !== undefined ? layout.w : item.tempVisual.width,
            "height": layout && layout !== undefined ? layout.h : item.tempVisual.height,
            "x": layout && layout !== undefined ? layout.x : item.tempVisual.x,
            "y": layout && layout !== undefined ? layout.y : item.tempVisual.y
        }
        item.tempVisual = visual
        return visual
    }
}

const setToCardView = (gridHeader, sqlresult, item) => {
    
    if((sqlresult && sqlresult.length === 1) && ((!item.visual_type || item.visual_type === undefined) || (!item.visual_data || item.visual_data === undefined)) && (!item.visual || item.visual === undefined))
    {
        const card = sqlresult[0]
        const cardItem = []
        card.map((row, index) => {
            cardItem.push({
                "id": index,
                "column": gridHeader[index],
                "columnItem": "",
                "columnItemList": [card[index]],
                "columnToSum": gridHeader[index],
                "sum": card[index],
                "title": "",
                "description": ""
            })
        })
        const headerToMultiSelect = []
        gridHeader.map((item, index) => {
            headerToMultiSelect.push( {
                "id": index,
                "name": gridHeader[index]
            })
        })
        const cardObject = {
            "selectedViewOption": "Card",
            "cardItem": cardItem,
            "headerToMultiSelect": headerToMultiSelect,
            "width": item.tempVisual.width,
            "height": item.tempVisual.height,
            "x": item.tempVisual.x,
            "y": item.tempVisual.y
        }

        item.tempVisual = cardObject
    }else if(sqlresult && sqlresult.length > 1 && item.visual_data && item.visual_type === "Card"){
     
        const columnToSum =[]
        const column =[]
        const cardItem = []

        item.visual_data &&  item.visual_data.map(item => {
            column.push(item.dataLabel)
            columnToSum.push(item.dataValue)
        })

        column.length > 0 && column.map((item, index) => {
            const colIndex = gridHeader.indexOf(item);
            const sumIndex = gridHeader.indexOf(columnToSum[index]);
            const sum = sqlresult.reduce((acc, item) => {
                return acc + item[sumIndex];
            }, 0);

            cardItem.push({
                "id": index,
                "column": gridHeader[colIndex],
                "columnItem": "",
                "columnItemList": sqlresult.map(item => {
                    return item[sumIndex]
                }),
                "columnToSum": gridHeader[sumIndex],
                "sum": sum,
                "title": "",
                "description": ""
            })
        })
        const headerToMultiSelect = []
        gridHeader.map((item, index) => {
            headerToMultiSelect.push( {
                "id": index,
                "name": gridHeader[index]
            })
        })
        const cardObject = {
            "selectedViewOption": "Card",
            "cardItem": cardItem,
            "headerToMultiSelect": headerToMultiSelect,
            "width": item.tempVisual.width,
            "height": item.tempVisual.height,
            "x": item.tempVisual.x,
            "y": item.tempVisual.y
        }
        item.tempVisual = cardObject
    }
}

const GetCardItem = async (gridHeader, sqlresult, item, treeViewData) => {

    if(sqlresult && sqlresult.length === 1)
    {
        const card = sqlresult[0]
        const cardItem = []
        card.map((row, index) => {
            cardItem.push({
                "id": index,
                "column": gridHeader[index],
                "columnItem": "",
                "columnItemList": [card[index]],
                "columnToSum": gridHeader[index],
                "sum": card[index],
                "title": "",
                "description": ""
            })
        })
        const headerToMultiSelect = []
        gridHeader.map((item, index) => {
            headerToMultiSelect.push( {
                "id": index,
                "name": gridHeader[index]
            })
        })

        const cardObject = {
            "selectedViewOption": "Card",
            "cardItem": cardItem,
            "headerToMultiSelect": headerToMultiSelect,
        }

        return cardObject
    }else if(sqlresult && sqlresult.length > 1 && item.visual_data && item.visual_type === "Card"){
     
        const columnToSum =[]
        const column =[]
        const cardItem = []

        item.visual_data &&  item.visual_data.map(item => {
            column.push(item.dataLabel)
            columnToSum.push(item.dataValue)
        })

        column.length > 0 && column.map((item, index) => {
            const colIndex = gridHeader.indexOf(item);
            const sumIndex = gridHeader.indexOf(columnToSum[index]);
            const sum = sqlresult.reduce((acc, item) => {
                return acc + item[sumIndex];
            }, 0);

            cardItem.push({
                "id": index,
                "column": gridHeader[colIndex],
                "columnItem": "",
                "columnItemList": sqlresult.map(item => {
                    return item[sumIndex]
                }),
                "columnToSum": gridHeader[sumIndex],
                "sum": sum,
                "title": "",
                "description": ""
            })
        })
        const headerToMultiSelect = []
        gridHeader.map((item, index) => {
            headerToMultiSelect.push( {
                "id": index,
                "name": gridHeader[index]
            })
        })
        const cardObject = {
            "selectedViewOption": "Card",
            "cardItem": cardItem,
            "headerToMultiSelect": headerToMultiSelect,
            // "width": item.tempVisual.width,
            // "height": item.tempVisual.height,
            // "x": item.tempVisual.x,
            // "y": item.tempVisual.y
        }
        return cardObject
    }else if(sqlresult && sqlresult.length > 1 && item.visual_type === "Card") {
        delete item.visual;
        const { groupLevel, resultWithGrandTotal } = await RunDataConversionService(sqlresult, gridHeader)
        const cardItem = []
        const sumList = []
        const columnItemList = getColumnItemList();

        for (let i = 0; i < gridHeader.length - groupLevel; i++) {
            const sum = getGrandTotal(i);
            const parsedSum = parseFloat(sum).toFixed(2);
            sumList.push(parsedSum)
        }

        function getColumnItemList()
        {
            const columnItemList = []
            resultWithGrandTotal.map(item => {
                columnItemList.push({
                    id: item.sqlId,
                    row: item.name
                })
            })
            return columnItemList
        }
        function getGrandTotal(index)
        {
            const item = resultWithGrandTotal.find(i => i.sqlId === 'grand-total')
            if(item)
            {
                return item.value[index]
            }
            return 0
        }

        sumList.map((sum, i) => {
            const card = {
                id: i,
                column: gridHeader[i + groupLevel],
                columnIndex: i + groupLevel,
                columnItem: 'grand-total',
                columnItemList: columnItemList,
                columnToSum: gridHeader[i + groupLevel],
                columnIndexToSum: i,
                sum: sum,
                title: '',
                description: ''
            };

            cardItem.push(card);
        });

        const headerToMultiSelect = []
        gridHeader.map((item, index) => {
            headerToMultiSelect.push( {
                "id": index,
                "name": gridHeader[index]
            })
        })
        const cardObject = {
            "selectedViewOption": "Card",
            "cardItem": cardItem,
            "headerToMultiSelect": headerToMultiSelect,
        }

        return cardObject
    }
}
const defaultCardColor = (index) => {
    const color = ['#ffffff',
    '#c7d9ff'
    ,'#f7c11d3b'
    ,'#007F0E3b'
    ,'#13B5EA3b'
    ,'#E044A73b'
    ,'#744EC23b'
    ,'#0000003b'
    ,'#D645503b',
    '#FFB3BA', // light red
    '#FFDFBA', // light orange
    '#FFFFBA', // light yellow
    '#BAFFC9', // light green
    '#BAE1FF', // light blue
    '#E0BBE4', // lavender
    '#D5AAFF', // soft purple
    '#B5EAD7', // mint green
    '#C7CEEA', // periwinkle
    '#FFDAC1', // peach
    '#FFCCE5', // pink
    '#D0F4DE', // pale mint
    '#FEE1E8', // rose
    '#F6DFEB', // soft blush
    '#E4F9F5', // light aqua
    '#FBE4D8', // coral tint
    '#FDFD96', // pastel yellow
    '#C1F0F6', // light teal
    '#F8C8DC', // cotton candy pink
    '#F3EAC2']

    if(index > color.length - 1) return getRandomLightColor()

    return color[index]
}
const defaultControl = (index) => {
    const color = ['#202474'
    ,'#F7C11D'
    ,'#007F0E'
    ,'#13B5EA'
    ,'#E044A7'
    ,'#744EC2'
    ,'#000000'
    ,'#D64550']

    if(index > color.length - 1) return getRandomLightColor()

    return color[index]
}

const ProcessDefaultLinevisual = (sqlResult, header, groupLevel) => {
    const label = sqlResult.map( i => { return i[0] })
    const headerToMultiSelect = header.map((data, index) => {
        return { id: index, name: data }
    })
    const datasets = headerToMultiSelect.slice(1).reduce((acc, header, index) => {
        const val = sqlResult[0][index + 1]
        if (!isNaN(val)) { 
        // if (typeof sqlResult[0][index + 1] === 'number') { 
            acc.push({
                label: header.name,
                data: sqlResult.map(i => {
                    return i[index + 1]
                }),
                // colIndex: (index + 1) - groupLevel,
                backgroundColor: defaultControl(index),
                borderColor: defaultControl(index)
            });
        }
        return acc;
    }, []);

    const selectedGroups = headerToMultiSelect.slice(1).reduce((acc, header, index) => {
        const val = sqlResult[0][index + 1]
        if (!isNaN(val)) { 
            acc.push({
                label: header.name,
                data: header.name,
                colIndex: (index + 1) - groupLevel,
                color: defaultControl(index),
                isOpen: false
            });
        }
        return acc;
    }, []);

    let LineObject = {
        "selectedViewOption": "Line Chart",
        "selectedGroups": selectedGroups,
        "selectedGroup": null,
        "chartHeader": [],
        "selectedFooter": headerToMultiSelect[0],
        "selectedGraphHeaderOption": null,
        "headerToMultiSelect": headerToMultiSelect,
        "chartData": {
            "labels": label,
            "datasets": datasets
        }
    }
    return LineObject
}

export { processGraphView, processPieGraph, processCardView, processGridView, defaultControl, ProcessDefaultLinevisual, GetCardItem, defaultCardColor }